<div class="header-toolbar">
  <h1>{{ title }}</h1>
</div>

<form #form="ngForm" (ngSubmit)="save()" autocomplete="off">

  <!-- Toolbar -->
  <div class="main btn-toolbar">

    <button type="submit" class="btn" *ngIf="matrix" [disabled]="!canSave">
      <t-icon name="check"></t-icon>
      <span class="text">Importer</span>
    </button>

    &nbsp;

    <a class="btn" (click)="cancel()">
      <t-icon name="close"></t-icon>
      <span class="text">Annuler</span>
    </a>

  </div>

  <div class="form-group" *ngIf="!matrix">
    <label class="file-select" ng2FileDrop (fileOver)="isFileOver = $event" [uploader]="uploader" [ngClass]="{ 'over': isFileOver }"
      for="file">
      <t-icon name="attachment"></t-icon>
      <span class="text">Sélectionner un fichier .xlsx</span>
    </label>
    <input id="file" type="file" style="display: none" ng2FileSelect [uploader]="uploader" />
  </div>


  <div class="capitalisation"  *ngIf="matrix">
    <table>
      <tr>
        <th>&nbsp;</th>
        <th *ngFor="let group of matrix.groups" colspan="3" class="column op-column">
          {{ group }}
        </th>
      </tr>
      <tr>
        <th>
          Associés
        </th>
        <ng-container *ngFor="let group of matrix.groups">
          <th class="column">PP</th>
          <th>NP</th>
          <th>U</th>
        </ng-container>
      </tr>

      <tr *ngFor="let record of matrix.records">
        <th class="actions">
          <span>
            {{ record.name }}
            <ng-container *ngIf="record.record">
               &rarr; {{ record.record.name }}
            </ng-container>
          </span>
          <a *ngIf="record.record" class="action-btn" title="Dissocier l'enregistrement" (click)="unlinkRecord(record)">
            <t-icon name="link_off"></t-icon>
          </a>
          <a class="action-btn" title="Lier un enregistrement existant" (click)="linkRecord(record)">
            <t-icon name="search"></t-icon>
          </a>
        </th>
        <ng-container *ngFor="let group of record.groups">
          
          <td *ngIf="group.isEmpty" class="column disabled" colspan="3"></td>
          
          <ng-container *ngIf="!group.isEmpty">
            <td class="column">{{ group.pp }}</td>
            <td>{{ group.np }}</td>
            <td>{{ group.u }}</td>
          </ng-container>
        </ng-container>
      </tr>
    </table>
  </div>

</form>